import {
  DefaultButton,
  Icon,
  IconButton,
  Label,
  Pivot,
  PivotItem,
  PrimaryButton,
  Stack,
  Separator,
  PersonaSize,
  PersonaPresence,
  DetailsList,
  IColumn,
  CheckboxVisibility,
  Link,
  Dropdown,
  IIconProps,
} from '@fluentui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { _renderRow } from '../../control/function/detailList';
import { NoDataFound } from '../../control/noDataFound';
import { FileTypeAccept } from '../../common/constant/constantKey';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import useToken from '../account/login/useToken';
import { DialogContext } from '../../context/dialog.context';
import { commonfn } from '../../common/commonfn';
import moment from 'moment';
import Message from './messages';
import ModalEditModule from './modal/modalEditModule';
import { Loading } from '../../control/loading';
import { saveAs } from 'file-saver';
import DocumentViewer from '../../control/DocumentViewer';
import { Avatar } from '../../control/avatar';
import ModalViewTest from './modal/modalTestView';
import ModaProductSpecification from '../settings/products/modal/modalProductSpecification';

const MatrixItemsApi = new Api.MatrixItemsApi();
const MatrixDocumentsApi = new Api.MatrixDocumentsApi();
const DocumentsApi = new Api.DocumentsApi();
interface ModuleMatrixProps {
  Item: Api.MatrixGeneralModuleDetail;
  IsLocked: boolean;
}
const ModuleMatrix = ({ Item, IsLocked }: ModuleMatrixProps) => {
  const { userTokenInfo } = useToken();
  const { t } = useTranslation();
  const [isOpenModalEdit, SetIsOpenModalEdit] = React.useState(false);
  const [isOpenModalAddTest, SetIsOpenModalAddTest] = React.useState(false);
  const [detail, setDetail] = React.useState<Api.MatrixItemModuleDto | null>(null);
  const [listDocument, setListDocument] = React.useState<Api.DocumentDto[]>([]);
  const [isShowLoading, SetIsShowLoading] = React.useState(true);
  const [isOpenDocument, SetIsOpenDocument] = React.useState(false);
  const [documentFile, SetDocumentFile] = React.useState<any>();
  const [testView, SetTestView] = React.useState<any>();
  const { setMsgConfirmDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  React.useEffect(() => {
    setDetail(null);
    getDetailGeneral();
    //getDocuments();
  }, [Item]);

  const approveModule = async (status: boolean) => {
    if (!status) {
      setMsgConfirmDialog(t('AreYouSureYouWantToUnapproveThisModule'));
      setCallBackConfirmDialog({
        action: async (Id: number) => {
          await MatrixItemsApi.apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(Id || 0, status);
          getDetailGeneral();
        },
        param: Item.Id,
      });
    } else {
      await MatrixItemsApi.apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(Item.Id || 0, status);
      getDetailGeneral();
    }
  };

  const getDetailGeneral = async () => {
    let data = (await MatrixItemsApi.apiMatrixItemsMatrixItemModuleIdGet(Item.Id || 0)).data
      .Data as Api.MatrixItemModuleDto;
    setDetail(data);
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };

  const getDocuments = async () => {
    let data = (await MatrixDocumentsApi.apiMatrixDocumentsMatrixModuleIdGet(Item.Id || 0)).data.Data;
    await getDetailGeneral();
    setListDocument(data || []);
  };

  const deleteItem = (docId: number) => {
    if (!Item) return;
    setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
    setCallBackConfirmDialog({
      action: (testId: number) => {
        MatrixDocumentsApi.apiMatrixDocumentsMatrixModuleIdDelete(Item.Id || 0, [docId]).then(() => {
          getDocuments();
        });
      },
      param: Item,
    });
  };
  const downloadItem = (item: any, preview?: boolean) => {
    if (preview) {
      SetDocumentFile(item);
      SetIsOpenDocument(true);
      return;
    }
    DocumentsApi.apiDocumentsIdGet(item.Id, {
      responseType: 'blob',
    }).then((response) => {
      const rs = response as any;
      saveAs((response as any).data as Blob, `${item.Name}`);
    });
  };

  const handleOnChange = (e: any) => {
    if (!Item) return;
    const formData = new FormData();
    for (let index = 0; index < e.target.files.length; index++) {
      const element = e.target.files[index];
      formData.append('documents ', element);
    }
    MatrixDocumentsApi.apiMatrixDocumentsMatrixModuleIdPost(Item.Id || 0, formData as any).then(() => {
      getDocuments();
      let a = document.getElementById('uploadFile') as any;
      a['value'] = '';
    });
  };

  const checkDeadline = (detail: any) => {
    const status = detail.Status;
    if (status === 'OverDue') {
      if (moment().diff(moment(detail.Deadline), 'd') > 0) {
        return '(' + moment().diff(moment(detail.Deadline), 'd') + ' days)';
      } else {
        return '(' + t('ExpiredToday') + ')';
      }
    }
    return '';
  };

  const changeModule = () => {
    if (detail?.Status === 'OnGoing') {
      setDetail({ ...detail, Status: Api.MatrixItemStatusEnum.InProcess });
    }
  };

  const getPerson = (name: string, date: string) => {
    if (name) {
      return name + ' ' + t('On') + ' ' + moment(date).format('DD/MM/yyyy hh:mm');
    }
    return '-';
  };
  
  const [isOpenModal, SetIsOpenModal] = React.useState(false);

  const _columns = [
    {
      key: 'Name',
      name: t('Name'),
      className: 'flex-center',
      isResizable: true,
      onRender: (item: Api.Test) => {
        return item.Name;
      },
    },
    {
      key: 'TestDate',
      name: t('TestDate'),
      className: 'flex-center',
      isResizable: true,
      minWidth: 200,
      maxWidth: 200,
      onRender: (item: Api.Test) => {
        return moment(item.TestDate).format('DD/MM/yyyy');
      },
    },
    {
      key: 'ExpiredDate',
      name: t('ExpiredDate'),
      className: 'flex-center',
      isResizable: true,
      minWidth: 200,
      maxWidth: 200,
      onRender: (item: Api.Test) => {
        return moment(item.ExpiredDate).format('DD/MM/yyyy');
      },
    },
    {
      key: 'Status',
      name: t('Status'),
      className: 'flex-center',
      isResizable: true,
      minWidth: 200,
      maxWidth: 200,
      onRender: (item: Api.Test) => {
        let status = commonfn.getTestStatus(item);
        let iconName = 'Clock';
        if (status === Api.TestStatusQueryEnum.Approved) {
          iconName = 'SkypeCircleCheck';
        }
        return (
          <>
            <Icon iconName={iconName} className={status} style={{}}></Icon>&nbsp; <span>{t(status)}</span>
          </>
        );
      },
    },
    {
      key: 'View',
      name: '',
      className: 'flex-center',
      isResizable: true,
      onRender: (item: Api.Test) => {
        return (
          <Link
            onClick={() => {
              SetTestView(item);
            }}
          >
            {t('View')}
          </Link>
        );
      },
    },
  ] as IColumn[];
  return (
    <div className="matrix-detail margin-left-0 margin-right-0 page-content">
      <Loading isShow={isShowLoading}></Loading>
      <div dir="ltr">
        <div className="display-flex">
          {userTokenInfo && userTokenInfo.Role !== 'Vendor' && !IsLocked ? (
            <Stack horizontal className="header-action margin-left-auto">
              {!detail?.IsApproved && (
                <>
                  &nbsp; &nbsp;
                  <DefaultButton
                    text={t('Edit')}
                    onClick={() => {
                      SetIsOpenModalEdit(true);
                    }}
                  />
                </>
              )}
              {detail?.IsApproved && (
                <>
                  &nbsp; &nbsp;
                  <DefaultButton
                    text={t('UnApprove')}
                    className={''}
                    onClick={() => {
                      approveModule(false);
                    }}
                  ></DefaultButton>
                </>
              )}
              {!detail?.IsApproved && (
                <>
                  &nbsp; &nbsp;
                  <PrimaryButton
                    text={t('Approve')}
                    className={''}
                    onClick={() => {
                      approveModule(true);
                    }}
                  ></PrimaryButton>
                </>
              )}
            </Stack>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row flex-center">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Module')}</Label>
          </div>
          <div className="ms-Grid-col">{detail?.Module?.Name}</div>
        </div>
        {
          detail?.Module?.ModuleType === 'Component' &&
          <div className="ms-Grid-row flex-center">
            <div className="label ms-Grid-col ms-lg3">
              <Label>{t('ComponentModel')}</Label>
            </div>
              {detail?.ComponentModelName ? <div className="ms-Grid-col">{detail?.ComponentModelName}</div>
                : <div className="ms-Grid-col">
                  <DefaultButton text="Update" onClick={()=>SetIsOpenModal(true)} allowDisabledFocus />
                </div>
              }
            
          </div>
        }
        <div className="ms-Grid-row flex-center">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Status')}</Label>
          </div>
          <div className="ms-Grid-col display-flex">
            {detail?.Status === 'Approved' ? (
              <Icon className={'Approved'} iconName="SkypeCircleCheck"></Icon>
            ) : detail?.Status === 'OverDue' ? (
              <Icon className={'OverDue'} iconName="Warning"></Icon>
            ) : detail?.Status === 'OnGoing' ? (
              <Icon className={'OnGoing'} iconName="Clock"></Icon>
            ) : (
              <Icon className={'Pending'} iconName="CircleHalfFull"></Icon>
            )}
            &nbsp;{t(detail?.Status || '')} {detail && checkDeadline(detail)}
          </div>
        </div>
        <div className="ms-Grid-row flex-center">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('ResponsiveStep')}</Label>
          </div>
          <div className="ms-Grid-col">
            {detail?.ReponsiveUser ? (
              <Avatar
                keyColor={detail?.ReponsiveUser?.FullName || ''}
                imageInitials={commonfn.getNameInitial(detail?.ReponsiveUser?.FullName || '')}
                text={detail?.ReponsiveUser?.FullName || ''}
                size={PersonaSize.size32}
                presence={PersonaPresence.none}
                className={detail?.Vendors && detail?.Vendors?.length > 3 ? 'margin-right' : ''}
                IsShowTooltip={true}
                hidePersonaDetails={detail?.Vendors && detail?.Vendors?.length > 3 ? true : false}
                RandomColor={true}
              />
            ) : (
              '-'
            )}
          </div>
        </div>
        <div className="ms-Grid-row flex-center">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('LastUpdated')}</Label>
          </div>
          <div className="ms-Grid-col">
            {getPerson(detail?.LastUpdated?.FullName || '', detail?.LastModifiedOn || '')}
          </div>
        </div>
        <div className="ms-Grid-row flex-center">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Deadline')}</Label>
          </div>
          <div className="ms-Grid-col">
            <span className={commonfn.getModuleStatus(detail) === 'OverDue' ? 'OverDue' : ''}>
              {detail?.Deadline ? moment(detail?.Deadline).format('DD/MM/yyyy') : '-'}
            </span>
          </div>
        </div>
        {/* {(detail?.Module?.ComponentType || Api.ModuleTypeEnum.Product) === Api.ModuleTypeEnum.Component && (
          <div className="ms-Grid-row flex-center">
            <div className="label ms-Grid-col ms-lg3">
              <Label>{t('Component')}</Label>
            </div>
            <div className="ms-Grid-col">
              {detail?.Component?.ComponentBrand?.Name + ' - ' + detail?.Component?.Name}
            </div>
          </div>
        )} */}

        <div className="ms-Grid-row flex-center">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Description')}</Label>
          </div>
          <div className="ms-Grid-col">{detail?.Description || '-'}</div>
        </div>
      </div>
      {detail && detail.Module?.ModuleType !== Api.ModuleTypeEnum.Product && (
        <div>
          <Separator />
          <h2>{t('TestList')}</h2>
          {detail?.Tests && detail?.Tests.length > 0 && (
            <DetailsList
              items={detail?.Tests || []}
              columns={_columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              isHeaderVisible={true}
            />
          )}
          <NoDataFound isShow={!detail?.Tests || detail?.Tests?.length === 0}></NoDataFound>
        </div>
      )}
      <div className="margin-top">
        <Pivot
          className="tab"
          onLinkClick={(item?: PivotItem) => {
            if (item?.props.itemKey === 'Documents') {
              getDocuments();
            }
          }}
        >
          <PivotItem headerText={t('Messages')} itemKey={'Messages'} className="margin-top">
            <Message Id={detail?.Id || 0} IsLocked={IsLocked} OnChange={changeModule} />
          </PivotItem>
          <PivotItem headerText={t('Documents')} itemKey={'Documents'}>
            <div className={'list margin-top'}>
              <div className="ms-Grid-row">
                {listDocument?.map((o) => {
                  return (
                    <div key={o.Id} className="item flex-center">
                      <IconButton
                        className={'CloudDownload'}
                        iconProps={{ iconName: 'CloudDownload' }}
                        onClick={() => {
                          downloadItem(o);
                        }}
                      ></IconButton>
                      <a
                        onClick={() => {
                          downloadItem(o, true);
                        }}
                      >
                        <Icon iconName={'Attach'}></Icon>{' '}
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{o.Name}</span>
                      </a>
                      {o.DocumentFrom === 'Document' && (
                        <IconButton
                          className={'delete onHover'}
                          iconProps={{ iconName: 'Delete' }}
                          onClick={() => {
                            deleteItem(o.Id || 0);
                          }}
                        ></IconButton>
                      )}
                    </div>
                  );
                })}
                <NoDataFound isShow={!listDocument?.length} />
              </div>
              {!IsLocked && (
                <DefaultButton
                  text={t('UploadDocuments')}
                  iconProps={{ iconName: 'CloudUpload' }}
                  style={{ marginTop: 20 }}
                  onClick={() => {
                    let a = document.getElementById('uploadFile');
                    if (a) {
                      a.click();
                    }
                  }}
                ></DefaultButton>
              )}
              <input
                id="uploadFile"
                multiple
                accept={FileTypeAccept.FileAcceptTests}
                style={{ display: 'none' }}
                type="file"
                onChange={handleOnChange}
              />
            </div>
          </PivotItem>
        </Pivot>
      </div>
      {isOpenDocument && (
        <DocumentViewer
          Item={documentFile}
          IsOpen={isOpenDocument}
          onCloseModal={() => {
            SetIsOpenDocument(false);
          }}
        ></DocumentViewer>
      )}
      <ModalEditModule
        IsOpen={isOpenModalEdit}
        onSaveClick={() => {
          getDetailGeneral();
        }}
        onCloseModal={() => {
          SetIsOpenModalEdit(false);
        }}
        Item={detail}
      ></ModalEditModule>
      {!!testView && (
        <ModalViewTest
          IsOpen={!!testView}
          Item={testView}
          onCloseModal={() => {
            SetTestView(null);
          }}
        ></ModalViewTest>
      )}

        {isOpenModal && (
        <ModaProductSpecification
          IsOpen={isOpenModal}
          ProductId={detail?.MatrixItem?.ProductId ?? 0}
          Item={[detail?.Specification ?? {}]}
          IsOverride={true}
          onCloseModal={() => {
            SetIsOpenModal(false);
          }}
          onSaveClick={() => {
            getDetailGeneral();
          }}
        ></ModaProductSpecification>
      )}

    </div>
  );
};
export default ModuleMatrix;
